/* Hollen founding list signup.
   Posts to Klaviyo's client subscriptions API (public key only, no secrets).
   Each form carries its list ID, public key and a source label in data attributes,
   set from the section settings in the theme editor. */
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var KLAVIYO_REVISION = '2024-10-15';

  function init(root) {
    (root || document).querySelectorAll('form[data-hollen-signup]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', function (e) { onSubmit(e, form); });
    });
  }

  function onSubmit(event, form) {
    event.preventDefault();
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var error = form.querySelector('[data-error]');
    var wrapper = form.closest('[data-signup-wrapper]');
    var success = wrapper ? wrapper.querySelector('[data-success]') : null;
    var email = (input.value || '').trim();

    // Honeypot: bots fill hidden fields, people don't.
    var trap = form.querySelector('input[name="company_website"]');
    if (trap && trap.value) return;

    if (!EMAIL_RE.test(email)) {
      input.setAttribute('aria-invalid', 'true');
      error.textContent = form.dataset.invalidMessage || 'Please enter a valid email address.';
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    error.textContent = '';

    var label = button.textContent;
    button.disabled = true;
    button.textContent = form.dataset.busyLabel || 'Joining…';

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.dataset.source || 'Hollen founding page',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  hollen_founding_list: true,
                  hollen_signup_location: form.dataset.location || 'unknown',
                  hollen_signup_page: window.location.pathname
                },
                
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
      }
    };

    fetch('   https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
        form.hidden = true;
        if (success) {
          success.hidden = false;
          success.focus();
        }
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', { form_location: form.dataset.location || 'unknown', list: 'hollen_founding' });
        }
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead', { content_name: 'Hollen founding list' });
        }
        // For pixels set up in Shopify Customer events (e.g. the Facebook & Instagram app),
        // subscribe a custom pixel to 'hollen_founding_signup'.
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('hollen_founding_signup', { location: form.dataset.location || 'unknown' });
        }
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = label;
        error.textContent = form.dataset.failMessage || 'Sorry, something went wrong. Please try again.';
      });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
